(function (ws) {
    'use strict';
    ws.collections.quoteQuickEntryProducts = Backbone.Collection.extend({
        url: globals.path.api.westcon.cartAdd,

        /**
         * Parse API response
         * @param {Object} data
         * @returns {*|string}
         */
        parse: function(data) {
            return data.data;
        },

        /**
         * Initialize
         */
        initialize: function() {
            this.model = ws.models.quoteQuickEntry;
        }
    });
})(westcon);
